export const css = {
    root: 'JP88AI2t',
    ' _key': 'afcpe-theme/dojo/grid-body'
};
export default css;
